import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/CadastroUsuario.css";
import "../styles/global.css";

const CadastroDisciplina = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    codigo: "",
    nome: "",
    ementa: ""
  });

  const [errors, setErrors] = useState({});
  const [sucesso, setSucesso] = useState(false);
  const [erroGeral, setErroGeral] = useState(""); // ➡️ novo estado
  

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validarFormulario = () => {
    const novosErros = {};
    if (!formData.codigo.trim()) novosErros.codigo = "Código é obrigatório";
    if (!formData.nome.trim()) novosErros.nome = "Nome é obrigatório";
    setErrors(novosErros);
    return Object.keys(novosErros).length === 0;
  };

  const renderErro = (campo) => {
    return errors[campo] && <div className="mensagem-erro">{errors[campo]}</div>;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validarFormulario()) return;
  
    try {
      const clienteId = localStorage.getItem("cliente_id");
  
      const payload = {
        ...formData,
        cliente_id: clienteId,
        usuario_id: parseInt(localStorage.getItem("user_id"), 10)
      };
  
      const response = await fetch("http://localhost:5000/api/disciplinas/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });
  
      const data = await response.json(); // 🔵 Ler a resposta para tratar erro
  
      if (response.ok) {
        setSucesso(true);
        setErroGeral(""); // 🔵 limpar erro se sucesso
        setFormData({ codigo: "", nome: "", ementa: "" });
        setTimeout(() => {
          setSucesso(false);
          navigate("/disciplinas");
        }, 1000);
      } else {
        setErroGeral(data.erro || "Erro ao cadastrar disciplina.");
      }
    } catch (error) {
      console.error("Erro de conexão:", error);
      setErroGeral("Erro de conexão com o servidor.");
    }
  }; // <<< Aqui fecha corretamente a função handleSubmit
  
    
  return (
    <div className="form-wrapper">
      <h2 className="form-title">Cadastro de Disciplina</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-row-horizontal">
          <div className="form-group largura-30">
            <label>Código da Disciplina</label>
            <input
              type="text"
              name="codigo"
              value={formData.codigo}
              onChange={handleChange}
              maxLength={20}
            />
            {renderErro("codigo")}
          </div>

          <div className="form-group largura-70">
            <label>Nome da Disciplina</label>
            <input
              type="text"
              name="nome"
              value={formData.nome}
              onChange={handleChange}
              maxLength={100}
            />
            {renderErro("nome")}
          </div>
        </div>

        <div className="form-group">
          <label>Ementa</label>
          <textarea
            name="ementa"
            rows="5"
            value={formData.ementa || ""}
            onChange={handleChange}
            style={{
              fontSize: "0.7rem",
              fontFamily: "Arial, sans-serif",
              padding: "8px",
            }}
          ></textarea>
        </div>

        <div className="form-actions">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => navigate("/disciplinas")}
          >
            Cancelar
          </button>
          <button type="submit" className="btn btn-primary">
            Salvar
          </button>
        </div>

        {sucesso && (
          <div className="mensagem-sucesso">
            Disciplina cadastrada com sucesso!
          </div>
        )}
        {erroGeral && (
  <div className="mensagem-erro" style={{ marginTop: "10px" }}>
    {erroGeral}
  </div>
)}

      </form>
    </div>
  );
};

export default CadastroDisciplina;
